export const MakeInteractiveIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M6.675 13.908c.15.25.333.484.541.692a3.943 3.943 0 005.567 0 3.924 3.924 0 001.1-2.225M6.116 11.258a3.9 3.9 0 011.1-2.225 3.943 3.943 0 015.567 0c.216.217.392.45.542.692"
            ></path>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M6.517 16.133v-2.225h2.225M13.483 7.5v2.225h-2.225"
            ></path>
            <path
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M18.334 9.167v5c0 3.333-.834 4.166-4.167 4.166H5.834c-3.334 0-4.167-.833-4.167-4.166V5.833c0-3.333.833-4.166 4.167-4.166h1.25c1.25 0 1.525.366 2 1l1.25 1.666c.316.417.5.667 1.333.667h2.5c3.333 0 4.167.833 4.167 4.167z"
            ></path>
        </svg>
    );
};
export const ActiveMakeInteractiveIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M6.675 13.908c.15.25.333.484.541.692a3.943 3.943 0 005.567 0 3.924 3.924 0 001.1-2.225M6.116 11.258a3.9 3.9 0 011.1-2.225 3.943 3.943 0 015.567 0c.216.217.392.45.542.692"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M6.517 16.133v-2.225h2.225M13.483 7.5v2.225h-2.225"
            ></path>
            <path
                stroke="#3B82F6"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M18.334 9.167v5c0 3.333-.834 4.166-4.167 4.166H5.834c-3.334 0-4.167-.833-4.167-4.166V5.833c0-3.333.833-4.166 4.167-4.166h1.25c1.25 0 1.525.366 2 1l1.25 1.666c.316.417.5.667 1.333.667h2.5c3.333 0 4.167.833 4.167 4.167z"
            ></path>
        </svg>
    );
};

export const ScratchIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.334 8.333V12.5c0 4.167-1.667 5.833-5.834 5.833h-5c-4.166 0-5.833-1.666-5.833-5.833v-5c0-4.167 1.667-5.833 5.833-5.833h4.167"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M10.05 13.75V9.583M12.084 11.667H7.917"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.334 8.333H15c-2.5 0-3.333-.833-3.333-3.333V1.667l6.667 6.666z"
            ></path>
        </svg>
    );
};
export const ActiveScratchIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.334 8.333V12.5c0 4.167-1.667 5.833-5.834 5.833h-5c-4.166 0-5.833-1.666-5.833-5.833v-5c0-4.167 1.667-5.833 5.833-5.833h4.167"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M10.05 13.75V9.583M12.084 11.667H7.917"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.334 8.333H15c-2.5 0-3.333-.833-3.333-3.333V1.667l6.667 6.666z"
            ></path>
        </svg>
    );
};
export const FillInTheBlankIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M13.334 1.667H6.667c-3.333 0-5 1.666-5 5V17.5c0 .458.375.833.833.833h10.834c3.333 0 5-1.666 5-5V6.667c0-3.334-1.667-5-5-5z"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M10.758 6.533l-4.325 4.325a1.49 1.49 0 00-.358.725l-.233 1.65c-.084.6.333 1.017.933.934l1.65-.234a1.49 1.49 0 00.725-.358l4.325-4.325c.742-.742 1.1-1.608 0-2.708-1.1-1.109-1.967-.759-2.717-.009zM10.142 7.15a3.907 3.907 0 002.708 2.708"
            ></path>
        </svg>
    );
};
export const ActiveFillInTheBlankIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M13.334 1.667H6.667c-3.333 0-5 1.666-5 5V17.5c0 .458.375.833.833.833h10.834c3.333 0 5-1.666 5-5V6.667c0-3.334-1.667-5-5-5z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M10.758 6.533l-4.325 4.325a1.49 1.49 0 00-.358.725l-.233 1.65c-.084.6.333 1.017.933.934l1.65-.234a1.49 1.49 0 00.725-.358l4.325-4.325c.742-.742 1.1-1.608 0-2.708-1.1-1.109-1.967-.759-2.717-.009zM10.142 7.15a3.907 3.907 0 002.708 2.708"
            ></path>
        </svg>
    );
};

export const MultipleChoiceIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#1A1A1A"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.333 7.1V3.317c0-1.175-.533-1.65-1.858-1.65h-3.367c-1.325 0-1.858.475-1.858 1.65v3.775c0 1.183.533 1.65 1.858 1.65h3.367c1.325.008 1.858-.467 1.858-1.642z"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.333 16.475v-3.367c0-1.325-.533-1.858-1.858-1.858h-3.367c-1.325 0-1.858.533-1.858 1.858v3.367c0 1.325.533 1.858 1.858 1.858h3.367c1.325 0 1.858-.533 1.858-1.858z"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.167 15.05l.842.8 1.741-1.683"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8.75 7.1V3.317c0-1.175-.533-1.65-1.858-1.65H3.525c-1.325 0-1.858.475-1.858 1.65v3.775c0 1.183.533 1.65 1.858 1.65h3.367C8.217 8.75 8.75 8.275 8.75 7.1z"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.333 5.05l.842.8 1.741-1.683"
            ></path>
            <path
                stroke="#1A1A1A"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8.75 16.475v-3.367c0-1.325-.533-1.858-1.858-1.858H3.525c-1.325 0-1.858.533-1.858 1.858v3.367c0 1.325.533 1.858 1.858 1.858h3.367c1.325 0 1.858-.533 1.858-1.858z"
            ></path>
        </svg>
    );
};
export const ActiveMultipleChoiceIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.333 7.1V3.317c0-1.175-.533-1.65-1.858-1.65h-3.367c-1.325 0-1.858.475-1.858 1.65v3.775c0 1.183.533 1.65 1.858 1.65h3.367c1.325.008 1.858-.467 1.858-1.642z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.333 16.475v-3.367c0-1.325-.533-1.858-1.858-1.858h-3.367c-1.325 0-1.858.533-1.858 1.858v3.367c0 1.325.533 1.858 1.858 1.858h3.367c1.325 0 1.858-.533 1.858-1.858z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.167 15.05l.842.8 1.741-1.683"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8.75 7.1V3.317c0-1.175-.533-1.65-1.858-1.65H3.525c-1.325 0-1.858.475-1.858 1.65v3.775c0 1.183.533 1.65 1.858 1.65h3.367C8.217 8.75 8.75 8.275 8.75 7.1z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.333 5.05l.842.8 1.741-1.683"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8.75 16.475v-3.367c0-1.325-.533-1.858-1.858-1.858H3.525c-1.325 0-1.858.533-1.858 1.858v3.367c0 1.325.533 1.858 1.858 1.858h3.367c1.325 0 1.858-.533 1.858-1.858z"
            ></path>
        </svg>
    );
};
export const WordsearchIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                fill="#212121"
                d="M9.4 9.714H6.6c-.328 0-.6-.226-.6-.5 0-.273.272-.5.6-.5h2.8c.328 0 .6.227.6.5 0 .274-.272.5-.6.5z"
            ></path>
            <path
                fill="#212121"
                d="M10.683 11.714L8 5.743l-2.683 5.971L4 11.14l3.341-7.425H8.66L12 11.14l-1.317.575z"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.334 10.548V7.214c0-4.166-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.667-5.833 5.833v5c0 4.167 1.667 5.834 5.833 5.834h3.334"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M15.167 17.548a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM18.333 18.048l-.833-.834"
            ></path>
        </svg>
    );
};
export const ActiveWordsearchIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                fill="#3B82F6"
                d="M9.4 9.714H6.6c-.328 0-.6-.226-.6-.5 0-.273.272-.5.6-.5h2.8c.328 0 .6.227.6.5 0 .274-.272.5-.6.5z"
            ></path>
            <path
                fill="#3B82F6"
                d="M10.683 11.714L8 5.743l-2.683 5.971L4 11.14l3.341-7.425H8.66L12 11.14l-1.317.575z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.334 10.548V7.214c0-4.166-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.667-5.833 5.833v5c0 4.167 1.667 5.834 5.833 5.834h3.334"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M15.167 17.548a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM18.333 18.048l-.833-.834"
            ></path>
        </svg>
    );
};
export const CrosswordIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.3337 10.8334V7.50002C18.3337 3.33335 16.667 1.66669 12.5003 1.66669H7.50033C3.33366 1.66669 1.66699 3.33335 1.66699 7.50002V12.5C1.66699 16.6667 3.33366 18.3334 7.50033 18.3334H10.8337"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.69238 7.08337H18.3341"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.69238 12.9167H10.0007"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.0918 18.325V1.67505"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.9248 9.9917V1.67505"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.1667 17.8333C16.6394 17.8333 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8333 15.1667 17.8333Z"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3333 18.3333L17.5 17.5"
                stroke="#212121"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const ActiveCrosswordIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.3337 10.8334V7.50002C18.3337 3.33335 16.667 1.66669 12.5003 1.66669H7.50033C3.33366 1.66669 1.66699 3.33335 1.66699 7.50002V12.5C1.66699 16.6667 3.33366 18.3334 7.50033 18.3334H10.8337"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.69238 7.08337H18.3341"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.69238 12.9167H10.0007"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.0918 18.325V1.67505"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.9248 9.9917V1.67505"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.1667 17.8333C16.6394 17.8333 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8333 15.1667 17.8333Z"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3333 18.3333L17.5 17.5"
                stroke="#3B82F6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const WordScrambleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10.309 7.4h4.375M5.316 7.4l.625.625L7.816 6.15M10.309 13.233h4.375M5.316 13.233l.625.625 1.875-1.875"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M7.5 18.333h5c4.167 0 5.834-1.666 5.834-5.833v-5c0-4.167-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.666-5.833 5.833v5c0 4.167 1.667 5.833 5.833 5.833z"
            ></path>
        </svg>
    );
};
export const ActiveWordScrambleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10.309 7.4h4.375M5.316 7.4l.625.625L7.816 6.15M10.309 13.233h4.375M5.316 13.233l.625.625 1.875-1.875"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M7.5 18.333h5c4.167 0 5.834-1.666 5.834-5.833v-5c0-4.167-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.666-5.833 5.833v5c0 4.167 1.667 5.833 5.833 5.833z"
            ></path>
        </svg>
    );
};
export const MatchingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#292D32"
                strokeWidth="1.5"
                d="M4.558 7.5a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833zM14.141 12.5h2.5c.917 0 1.667.75 1.667 1.667v2.5c0 .916-.75 1.666-1.667 1.666h-2.5c-.916 0-1.666-.75-1.666-1.666v-2.5c0-.917.75-1.667 1.666-1.667z"
            ></path>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10 4.167h2.234c1.541 0 2.258 1.908 1.1 2.925l-6.659 5.825c-1.158 1.008-.441 2.916 1.092 2.916H10"
            ></path>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4.572 4.583h.01M15.405 15.417h.01"
            ></path>
        </svg>
    );
};
export const ActiveMatchingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeWidth="1.5"
                d="M4.558 7.5a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833zM14.141 12.5h2.5c.917 0 1.667.75 1.667 1.667v2.5c0 .916-.75 1.666-1.667 1.666h-2.5c-.916 0-1.666-.75-1.666-1.666v-2.5c0-.917.75-1.667 1.666-1.667z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10 4.167h2.234c1.541 0 2.258 1.908 1.1 2.925l-6.659 5.825c-1.158 1.008-.441 2.916 1.092 2.916H10"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4.572 4.583h.01M15.405 15.417h.01"
            ></path>
        </svg>
    );
};
export const MultiplicationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M11.666 13.467l-3.3-3.3M11.633 10.2l-3.3 3.3M8.334 5h3.333c1.667 0 1.667-.833 1.667-1.667 0-1.666-.834-1.666-1.667-1.666H8.334c-.834 0-1.667 0-1.667 1.666C6.667 5 7.5 5 8.334 5z"
            ></path>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 3.35c2.775.15 4.167 1.175 4.167 4.983v5c0 3.334-.833 5-5 5h-5c-4.167 0-5-1.666-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
        </svg>
    );
};
export const ActiveMultiplicationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M11.666 13.467l-3.3-3.3M11.633 10.2l-3.3 3.3M8.334 5h3.333c1.667 0 1.667-.833 1.667-1.667 0-1.666-.834-1.666-1.667-1.666H8.334c-.834 0-1.667 0-1.667 1.666C6.667 5 7.5 5 8.334 5z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 3.35c2.775.15 4.167 1.175 4.167 4.983v5c0 3.334-.833 5-5 5h-5c-4.167 0-5-1.666-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
        </svg>
    );
};

export const AdditionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
        >
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M12.334 12.095H7.667M10 9.81v4.666M8.334 5.286h3.333c1.667 0 1.667-.834 1.667-1.667 0-1.667-.834-1.667-1.667-1.667H8.334c-.834 0-1.667 0-1.667 1.667S7.5 5.286 8.334 5.286z"
            ></path>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 3.636c2.775.15 4.167 1.175 4.167 4.983v5c0 3.333-.833 5-5 5h-5c-4.167 0-5-1.667-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
        </svg>
    );
};
export const ActiveAdditionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M12.334 12.095H7.667M10 9.81v4.666M8.334 5.286h3.333c1.667 0 1.667-.834 1.667-1.667 0-1.667-.834-1.667-1.667-1.667H8.334c-.834 0-1.667 0-1.667 1.667S7.5 5.286 8.334 5.286z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 3.636c2.775.15 4.167 1.175 4.167 4.983v5c0 3.333-.833 5-5 5h-5c-4.167 0-5-1.667-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
        </svg>
    );
};
export const SubtractionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
        >
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M12.31 12.119H7.643M8.334 5.286h3.333c1.667 0 1.667-.834 1.667-1.667 0-1.667-.834-1.667-1.667-1.667H8.334c-.834 0-1.667 0-1.667 1.667S7.5 5.286 8.334 5.286z"
            ></path>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 3.636c2.775.15 4.167 1.175 4.167 4.983v5c0 3.333-.833 5-5 5h-5c-4.167 0-5-1.667-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
        </svg>
    );
};

export const ActiveSubtractionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M12.31 12.119H7.643M8.334 5.286h3.333c1.667 0 1.667-.834 1.667-1.667 0-1.667-.834-1.667-1.667-1.667H8.334c-.834 0-1.667 0-1.667 1.667S7.5 5.286 8.334 5.286z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 3.636c2.775.15 4.167 1.175 4.167 4.983v5c0 3.333-.833 5-5 5h-5c-4.167 0-5-1.667-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
        </svg>
    );
};

export const DivisionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19"
            fill="none"
            viewBox="0 0 20 19"
        >
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M8.334 4h3.333c1.667 0 1.667-.833 1.667-1.667 0-1.666-.834-1.666-1.667-1.666H8.334c-.834 0-1.667 0-1.667 1.666C6.667 4 7.5 4 8.334 4z"
            ></path>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 2.35c2.775.15 4.167 1.175 4.167 4.983v5c0 3.334-.833 5-5 5h-5c-4.167 0-5-1.666-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
            <circle cx="10" cy="7.464" r="0.75" fill="#212121"></circle>
            <path
                stroke="#292D32"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M11.866 10.081H8.133"
            ></path>
            <circle cx="10" cy="12.698" r="0.75" fill="#212121"></circle>
        </svg>
    );
};
export const ActiveDivisionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19"
            fill="none"
            viewBox="0 0 20 19"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M8.334 4h3.333c1.667 0 1.667-.833 1.667-1.667 0-1.666-.834-1.666-1.667-1.666H8.334c-.834 0-1.667 0-1.667 1.666C6.667 4 7.5 4 8.334 4z"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M13.333 2.35c2.775.15 4.167 1.175 4.167 4.983v5c0 3.334-.833 5-5 5h-5c-4.167 0-5-1.666-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
            ></path>
            <circle cx="10" cy="7.464" r="0.75" fill="#212121"></circle>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
                d="M11.866 10.081H8.133"
            ></path>
            <circle cx="10" cy="12.698" r="0.75" fill="#212121"></circle>
        </svg>
    );
};
export const MathCrosswordIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
        >
            <g
                stroke="#212121"
                strokeLinejoin="round"
                clipPath="url(#clip0_23055_25679)"
            >
                <path
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M18.334 11.548V8.214c0-4.166-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.667-5.833 5.833v5c0 4.167 1.667 5.834 5.833 5.834h3.334M1.692 7.798h16.642M1.692 13.631h8.309M7.092 19.04V2.39M12.925 10.706V2.389"
                ></path>
                <path
                    fill="#212121"
                    strokeWidth="0.2"
                    d="M14.931 15.11l.762-.486V19.2h-1.088a.556.556 0 00-.389.133.5.5 0 00-.149.385.52.52 0 00.146.383c.101.1.236.146.392.146h3.28a.57.57 0 00.4-.134h0l.003-.003c.1-.1.146-.236.146-.392a.5.5 0 00-.15-.385.57.57 0 00-.398-.133h-.99v-5.586c0-.157-.043-.293-.154-.378a.49.49 0 00-.336-.12.83.83 0 00-.33.075 2.42 2.42 0 00-.324.162h0l-.003.002-1.342.846a.583.583 0 00-.244.27h0l-.003.005a.56.56 0 00-.022.32h0l.002.006c.03.1.08.185.151.256h0l.004.003a.524.524 0 00.275.132h.002a.56.56 0 00.355-.08h0l.004-.003z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_23055_25679">
                    <path
                        fill="#fff"
                        d="M0 0H20V20H0z"
                        transform="translate(0 .714)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
};
export const ActiveMathCrosswordIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
        >
            <g
                stroke="#3B82F6"
                strokeLinejoin="round"
                clipPath="url(#clip0_23055_25679)"
            >
                <path
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M18.334 11.548V8.214c0-4.166-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.667-5.833 5.833v5c0 4.167 1.667 5.834 5.833 5.834h3.334M1.692 7.798h16.642M1.692 13.631h8.309M7.092 19.04V2.39M12.925 10.706V2.389"
                ></path>
                <path
                    fill="#3B82F6"
                    strokeWidth="0.2"
                    d="M14.931 15.11l.762-.486V19.2h-1.088a.556.556 0 00-.389.133.5.5 0 00-.149.385.52.52 0 00.146.383c.101.1.236.146.392.146h3.28a.57.57 0 00.4-.134h0l.003-.003c.1-.1.146-.236.146-.392a.5.5 0 00-.15-.385.57.57 0 00-.398-.133h-.99v-5.586c0-.157-.043-.293-.154-.378a.49.49 0 00-.336-.12.83.83 0 00-.33.075 2.42 2.42 0 00-.324.162h0l-.003.002-1.342.846a.583.583 0 00-.244.27h0l-.003.005a.56.56 0 00-.022.32h0l.002.006c.03.1.08.185.151.256h0l.004.003a.524.524 0 00.275.132h.002a.56.56 0 00.355-.08h0l.004-.003z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_23055_25679">
                    <path
                        fill="#fff"
                        d="M0 0H20V20H0z"
                        transform="translate(0 .714)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
};
export const HandwritingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#212121"
                d="M21 5.25h-7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75zM21 10.25h-7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75zM21 15.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75zM21 20.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75zM7.92 10.75H5.08c-1.54 0-2.33-.78-2.33-2.33V5.58c0-1.54.78-2.33 2.33-2.33h2.85c1.54 0 2.33.78 2.33 2.33v2.85c-.01 1.54-.79 2.32-2.34 2.32zm-2.84-6c-.71 0-.83.12-.83.83v2.85c0 .71.12.83.83.83h2.85c.71 0 .83-.12.83-.83V5.58c0-.71-.12-.83-.83-.83H5.08z"
            ></path>
        </svg>
    );
};
export const ActiveHandwritingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#3B82F6"
                d="M21 5.25h-7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75zM21 10.25h-7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75zM21 15.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75zM21 20.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75zM7.92 10.75H5.08c-1.54 0-2.33-.78-2.33-2.33V5.58c0-1.54.78-2.33 2.33-2.33h2.85c1.54 0 2.33.78 2.33 2.33v2.85c-.01 1.54-.79 2.32-2.34 2.32zm-2.84-6c-.71 0-.83.12-.83.83v2.85c0 .71.12.83.83.83h2.85c.71 0 .83-.12.83-.83V5.58c0-.71-.12-.83-.83-.83H5.08z"
            ></path>
        </svg>
    );
};
export const NametracingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10.417 18.333H7.5c-4.166 0-5.833-1.666-5.833-5.833v-5c0-4.167 1.667-5.833 5.833-5.833h5c4.167 0 5.834 1.666 5.834 5.833V10"
            ></path>
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M15.047 13.435h-.1a1.298 1.298 0 01-1.255-1.3c0-.721.58-1.302 1.301-1.302.72 0 1.301.587 1.301 1.301a1.283 1.283 0 01-1.247 1.301zM13.165 15.443c-.887.594-.887 1.561 0 2.155 1.008.674 2.662.674 3.67 0 .887-.594.887-1.561 0-2.155-1.008-.667-2.655-.667-3.67 0zM5.833 5.833H10M5.833 9.167h5.833"
            ></path>
        </svg>
    );
};
export const ActiveNametracingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10.417 18.333H7.5c-4.166 0-5.833-1.666-5.833-5.833v-5c0-4.167 1.667-5.833 5.833-5.833h5c4.167 0 5.834 1.666 5.834 5.833V10"
            ></path>
            <path
                stroke="#3B82F6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M15.047 13.435h-.1a1.298 1.298 0 01-1.255-1.3c0-.721.58-1.302 1.301-1.302.72 0 1.301.587 1.301 1.301a1.283 1.283 0 01-1.247 1.301zM13.165 15.443c-.887.594-.887 1.561 0 2.155 1.008.674 2.662.674 3.67 0 .887-.594.887-1.561 0-2.155-1.008-.667-2.655-.667-3.67 0zM5.833 5.833H10M5.833 9.167h5.833"
            ></path>
        </svg>
    );
};

export const ArrowUp = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#212121"
                d="M5.416 10l2.587-2.587L10.59 10a.664.664 0 10.94-.94L8.47 6a.664.664 0 00-.94 0L4.47 9.06c-.26.26-.26.68 0 .94.26.253.686.26.946 0z"
            ></path>
        </svg>
    );
};

export const ArrowDown = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#212121"
                d="M10.584 6L7.997 8.587 5.41 6a.664.664 0 10-.94.94L7.53 10c.26.26.68.26.94 0l3.06-3.06c.26-.26.26-.68 0-.94a.678.678 0 00-.946 0z"
            ></path>
        </svg>
    );
};

export const ArrowRightIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                stroke="#212121"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M7 12h9M13 16l4-4-4-4"
            ></path>
        </svg>
    );
};
export const ComingSoonIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="18"
            fill="none"
            viewBox="0 0 72 18"
        >
            <rect
                width="71.5"
                height="17.5"
                x="0.25"
                y="0.25"
                fill="url(#paint0_linear_23055_26169)"
                stroke="#3B82F6"
                strokeWidth="0.5"
                rx="8.75"
            ></rect>
            <path
                fill="#fff"
                d="M9.05 12.1c-.733 0-1.363-.147-1.89-.44-.52-.3-.92-.72-1.2-1.26-.28-.547-.42-1.19-.42-1.93 0-.553.08-1.05.24-1.49.16-.447.39-.827.69-1.14.3-.32.667-.563 1.1-.73.44-.173.933-.26 1.48-.26.367 0 .727.047 1.08.14.353.093.663.227.93.4a.64.64 0 01.28.32c.047.12.057.24.03.36a.562.562 0 01-.17.29.497.497 0 01-.31.14c-.12.007-.253-.037-.4-.13a2.221 2.221 0 00-.67-.29c-.24-.06-.483-.09-.73-.09-.473 0-.873.097-1.2.29a1.824 1.824 0 00-.74.84c-.167.367-.25.817-.25 1.35 0 .527.083.977.25 1.35.167.373.413.657.74.85.327.193.727.29 1.2.29.253 0 .503-.03.75-.09.247-.067.48-.167.7-.3.147-.087.277-.123.39-.11.12.007.22.047.3.12.08.073.133.167.16.28a.6.6 0 01-.02.34.635.635 0 01-.24.3 3.048 3.048 0 01-.96.45c-.367.1-.74.15-1.12.15zm5.275 0c-.506 0-.946-.103-1.32-.31a2.17 2.17 0 01-.87-.88c-.206-.387-.31-.84-.31-1.36 0-.393.057-.743.17-1.05.12-.313.29-.58.51-.8.22-.227.484-.397.79-.51.307-.12.65-.18 1.03-.18.507 0 .947.103 1.32.31.374.207.664.5.87.88.207.38.31.83.31 1.35 0 .393-.06.747-.18 1.06-.113.313-.28.583-.5.81-.22.22-.483.39-.79.51-.306.113-.65.17-1.03.17zm0-.95c.247 0 .464-.06.65-.18.187-.12.33-.297.43-.53.107-.24.16-.537.16-.89 0-.533-.113-.93-.34-1.19-.226-.267-.526-.4-.9-.4a1.134 1.134 0 00-1.09.71c-.1.233-.15.527-.15.88 0 .527.114.927.34 1.2.227.267.527.4.9.4zm4.172.93c-.2 0-.353-.053-.46-.16-.107-.113-.16-.273-.16-.48V7.66c0-.207.053-.363.16-.47.107-.107.257-.16.45-.16s.343.053.45.16c.107.107.16.263.16.47v.73l-.11-.3c.133-.333.34-.597.62-.79.28-.193.613-.29 1-.29.393 0 .717.093.97.28.253.187.43.473.53.86h-.14c.133-.353.353-.63.66-.83.307-.207.66-.31 1.06-.31.373 0 .68.073.92.22.247.147.43.37.55.67.12.293.18.667.18 1.12v2.42c0 .207-.057.367-.17.48-.107.107-.26.16-.46.16s-.353-.053-.46-.16c-.107-.113-.16-.273-.16-.48V9.07c0-.373-.063-.647-.19-.82-.12-.173-.327-.26-.62-.26-.327 0-.583.117-.77.35-.187.227-.28.543-.28.95v2.15c0 .207-.053.367-.16.48-.107.107-.26.16-.46.16s-.357-.053-.47-.16c-.107-.113-.16-.273-.16-.48V9.07c0-.373-.063-.647-.19-.82-.12-.173-.323-.26-.61-.26-.327 0-.583.117-.77.35-.187.227-.28.543-.28.95v2.15c0 .427-.21.64-.63.64zm8.75-.01c-.2 0-.354-.06-.46-.18-.107-.12-.16-.287-.16-.5V7.72c0-.22.053-.387.16-.5.106-.12.26-.18.46-.18s.353.06.46.18c.113.113.17.28.17.5v3.67c0 .213-.054.38-.16.5-.107.12-.264.18-.47.18zm0-5.96c-.234 0-.417-.057-.55-.17-.127-.12-.19-.283-.19-.49 0-.213.063-.377.19-.49.133-.113.316-.17.55-.17.24 0 .423.057.55.17.126.113.19.277.19.49 0 .207-.064.37-.19.49-.127.113-.31.17-.55.17zm2.548 5.97c-.2 0-.353-.053-.46-.16-.106-.113-.16-.273-.16-.48V7.66c0-.207.054-.363.16-.47.107-.107.257-.16.45-.16.194 0 .344.053.45.16.107.107.16.263.16.47v.68l-.11-.25c.147-.353.374-.62.68-.8.314-.187.667-.28 1.06-.28.394 0 .717.073.97.22.254.147.444.37.57.67.127.293.19.667.19 1.12v2.42c0 .207-.053.367-.16.48-.106.107-.26.16-.46.16s-.356-.053-.47-.16c-.106-.113-.16-.273-.16-.48V9.08c0-.38-.073-.657-.22-.83-.14-.173-.36-.26-.66-.26-.366 0-.66.117-.88.35-.213.227-.32.53-.32.91v2.19c0 .427-.21.64-.63.64zm7.51 1.82c-.36 0-.71-.033-1.05-.1a3.486 3.486 0 01-.91-.31.575.575 0 01-.26-.24c-.04-.093-.053-.19-.04-.29a.582.582 0 01.12-.25.508.508 0 01.24-.15.379.379 0 01.29.04c.293.147.57.24.83.28.267.047.493.07.68.07.447 0 .78-.11 1-.33.227-.213.34-.533.34-.96v-.9h.09c-.1.34-.31.613-.63.82-.313.2-.67.3-1.07.3-.44 0-.823-.1-1.15-.3a2.074 2.074 0 01-.76-.86c-.18-.367-.27-.793-.27-1.28 0-.367.05-.697.15-.99.107-.3.253-.557.44-.77.193-.213.423-.377.69-.49.273-.12.573-.18.9-.18.413 0 .773.103 1.08.31.313.2.517.467.61.8l-.1.25v-.71c0-.207.053-.363.16-.47.113-.107.267-.16.46-.16.2 0 .353.053.46.16.107.107.16.263.16.47v3.85c0 .793-.21 1.39-.63 1.79-.42.4-1.03.6-1.83.6zm-.03-2.97c.26 0 .483-.06.67-.18.187-.12.33-.29.43-.51.107-.227.16-.493.16-.8 0-.46-.113-.82-.34-1.08-.227-.267-.533-.4-.92-.4-.26 0-.483.06-.67.18-.187.12-.333.29-.44.51-.1.22-.15.483-.15.79 0 .46.113.823.34 1.09.227.267.533.4.92.4zm9.05 1.17c-.293 0-.587-.023-.88-.07a4.572 4.572 0 01-.83-.19 3.414 3.414 0 01-.7-.34.646.646 0 01-.3-.62.609.609 0 01.13-.29.455.455 0 01.27-.16c.107-.02.223.01.35.09.293.173.603.3.93.38.327.08.67.12 1.03.12.527 0 .91-.087 1.15-.26.24-.18.36-.41.36-.69a.656.656 0 00-.26-.55c-.167-.133-.457-.243-.87-.33l-1.1-.23c-.633-.133-1.107-.357-1.42-.67-.307-.32-.46-.74-.46-1.26a1.963 1.963 0 01.76-1.58 2.61 2.61 0 01.87-.44c.34-.107.713-.16 1.12-.16.4 0 .78.05 1.14.15.36.1.683.247.97.44a.511.511 0 01.21.27c.04.107.05.213.03.32a.5.5 0 01-.14.26.459.459 0 01-.28.13c-.107.013-.23-.02-.37-.1a2.848 2.848 0 00-.75-.3 3.553 3.553 0 00-.82-.09c-.307 0-.57.043-.79.13-.22.087-.39.21-.51.37a.9.9 0 00-.17.55c0 .24.08.433.24.58.16.14.433.25.82.33l1.09.23c.66.14 1.15.36 1.47.66.327.3.49.7.49 1.2 0 .32-.067.61-.2.87-.127.26-.313.483-.56.67-.24.187-.53.33-.87.43-.34.1-.723.15-1.15.15zm5.989 0c-.507 0-.947-.103-1.32-.31a2.17 2.17 0 01-.87-.88c-.207-.387-.31-.84-.31-1.36 0-.393.056-.743.17-1.05.12-.313.29-.58.51-.8.22-.227.483-.397.79-.51.306-.12.65-.18 1.03-.18.506 0 .946.103 1.32.31.373.207.663.5.87.88.206.38.31.83.31 1.35 0 .393-.06.747-.18 1.06-.114.313-.28.583-.5.81-.22.22-.484.39-.79.51-.307.113-.65.17-1.03.17zm0-.95c.246 0 .463-.06.65-.18.186-.12.33-.297.43-.53.106-.24.16-.537.16-.89 0-.533-.114-.93-.34-1.19-.227-.267-.527-.4-.9-.4a1.134 1.134 0 00-1.09.71c-.1.233-.15.527-.15.88 0 .527.113.927.34 1.2.226.267.526.4.9.4zm5.761.95c-.506 0-.946-.103-1.32-.31a2.17 2.17 0 01-.87-.88c-.206-.387-.31-.84-.31-1.36 0-.393.057-.743.17-1.05.12-.313.29-.58.51-.8.22-.227.484-.397.79-.51.307-.12.65-.18 1.03-.18.507 0 .947.103 1.32.31.374.207.664.5.87.88.207.38.31.83.31 1.35 0 .393-.06.747-.18 1.06-.113.313-.28.583-.5.81-.22.22-.483.39-.79.51-.306.113-.65.17-1.03.17zm0-.95c.247 0 .464-.06.65-.18.187-.12.33-.297.43-.53.107-.24.16-.537.16-.89 0-.533-.113-.93-.34-1.19-.226-.267-.526-.4-.9-.4a1.134 1.134 0 00-1.09.71c-.1.233-.15.527-.15.88 0 .527.114.927.34 1.2.227.267.527.4.9.4zm4.152.93c-.2 0-.353-.053-.46-.16-.107-.113-.16-.273-.16-.48V7.66c0-.207.053-.363.16-.47.107-.107.257-.16.45-.16s.343.053.45.16c.107.107.16.263.16.47v.68l-.11-.25c.147-.353.373-.62.68-.8.313-.187.667-.28 1.06-.28s.717.073.97.22c.253.147.443.37.57.67.127.293.19.667.19 1.12v2.42c0 .207-.053.367-.16.48-.107.107-.26.16-.46.16s-.357-.053-.47-.16c-.107-.113-.16-.273-.16-.48V9.08c0-.38-.073-.657-.22-.83-.14-.173-.36-.26-.66-.26-.367 0-.66.117-.88.35-.213.227-.32.53-.32.91v2.19c0 .427-.21.64-.63.64z"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear_23055_26169"
                    x1="18.947"
                    x2="57.164"
                    y1="2.25"
                    y2="13.803"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3B82F6"></stop>
                    <stop offset="1" stopColor="#4A3BF6"></stop>
                </linearGradient>
            </defs>
        </svg>
    );
};
